import { UserFriendlyError } from '@affine/error';
import type { useI18n } from '@affine/i18n';

type I18n = ReturnType<typeof useI18n>;

const formatRetryAfter = (language: string, retryAfterSeconds: number) => {
  const seconds = Math.max(1, Math.ceil(retryAfterSeconds));
  const [value, unit] =
    seconds >= 60 * 60
      ? [Math.ceil(seconds / (60 * 60)), 'hour']
      : seconds >= 60
        ? [Math.ceil(seconds / 60), 'minute']
        : [seconds, 'second'];

  return new Intl.NumberFormat(language, {
    style: 'unit',
    unit,
    unitDisplay: 'long',
  }).format(value);
};

export const getNewAccountSharingDelayNotification = (
  error: UserFriendlyError,
  t: I18n
) => {
  if ((error.name as string) !== 'NEW_ACCOUNT_SHARING_DELAY') {
    return null;
  }

  const retryAfterSeconds = error.data?.retryAfterSeconds;
  if (
    typeof retryAfterSeconds !== 'number' ||
    !Number.isFinite(retryAfterSeconds)
  ) {
    return null;
  }

  return {
    title: t.t('com.affine.share-menu.sharing-delay.notification.title'),
    message: t.t('com.affine.share-menu.sharing-delay.notification.message', {
      retryAfter: formatRetryAfter(t.language, retryAfterSeconds),
    }),
  };
};
